import { render } from "./SpotButton.vue?vue&type=template&id=8388dad8&scoped=true"
import script from "./SpotButton.vue?vue&type=script&lang=js"
export * from "./SpotButton.vue?vue&type=script&lang=js"

import "./SpotButton.vue?vue&type=style&index=0&id=8388dad8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8388dad8"]])

export default __exports__